import { useCallback, useEffect, useRef, useState } from "react"
import { Card, Col, Modal, Row, Spinner } from "react-bootstrap"
import Skeleton from "react-loading-skeleton"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"
import { key_local_storage_user, urlapi, url_images } from "../../lib/backend/data"
import { showAmmount } from "../../lib/helpers/helpers"
import { Box, debounce, Dialog } from "@mui/material"
import { FaSearch } from "react-icons/fa"
import { capitalizeFirstLetter } from "../../lib/helpers/main"
import useIsMobile from "../general/isMobile"

const BuscadorProductoPublico = (props) => {
    const {
        showResults,
        pagina_paginar,
        cond,
        typeView
    } = props
    const abortController = useRef(null)
    const [ codigoBusqueda, setCodigoBusqueda ] = useState('')
    const [ resultadosCodigoBusqueda, setResultadosCodigoBusqueda ] = useState([])
    const [ loadingCodigos, setLoadingCodigos ] = useState(false)
    const [ showDialog, setShowDialog ] = useState(false)
    const user = JSON.parse(localStorage.getItem(key_local_storage_user))
    const type_view = typeView || "simple"
    const tipo = props.tipo ? props.tipo : false
    const isMobile = useIsMobile()

    useEffect(() => {
        const concernedElement = document.querySelector(".word-search");
        if(concernedElement){
            document.addEventListener("mousedown", (event) => {
                if (!concernedElement.contains(event.target)){
                    setTimeout(() => {
                        setResultadosCodigoBusqueda([])
                    }, 200);
                } else {
                    if(codigoBusqueda){
                        if(codigoBusqueda.length > 3){
                            cancelRequest()
                            setTimeout(() => {
                                fetchCodigo(codigoBusqueda)
                            }, 100);
                        }
                    }
                }
              });
        }
    }, [])

    const fetchCodigo = (codigo_busqueda) => {
        if(!codigo_busqueda) return false
        abortController.current = new AbortController()
        setLoadingCodigos(true)
        return fetch(`${urlapi}/productos/search-v2`,{
            signal: abortController.current.signal,
            method: "POST",
            body: JSON.stringify({
                nombre: codigo_busqueda,
                pagina: pagina_paginar,
                condicion: cond
            }),
            headers: {
                'Content-Type': 'application/json',
            }
            })
            .then(res => res.json())
            .then(resultados => {
                if(!resultados){
                    toast.error("Sin datos del servidor")
                } else if(resultados.errorMessage){
                    toast.error(resultados.errorMessage)
                } else if(Array.isArray(resultados?.datos) !== false){
                    if(props.onResultados) props.onResultados(resultados?.datos)
                    setResultadosCodigoBusqueda(resultados?.datos)
                }
                return setLoadingCodigos(false)
            })
            .catch(error => {
                return setLoadingCodigos(false)
            })
    }

    const cancelRequest = () => abortController.current && abortController.current.abort();

    const actualizar = useCallback(debounce((data) => fetchCodigo(data), 1000), []);

    const handleChangeCodigo = (e) => {
        const { value } = e.target
        if(props.onChange) props.onChange(value)
        if(value){
            if(value.length > 3){
                cancelRequest()
                actualizar(value)
            }
        }
        return setCodigoBusqueda(value)
    }

    const handleSubmitCodigo = (e) => {
        e.preventDefault()
    }

    const seleccionarProducto = (pro) => {
        if(props.onSelectProduct) props.onSelectProduct(pro)
        setResultadosCodigoBusqueda([])
        setCodigoBusqueda('')
        setShowDialog(false)
    }

    const showComponentByType = (pro, extra_string) => {
        switch (tipo) {
            case "funcion":
                return <Row onClick={() => seleccionarProducto(pro)}>
                    <Col xs={3}><div style={{ width: "100%", aspectRatio: "1 / 1", borderRadius: 4, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center", backgroundImage: `url(${pro.img ? pro.img : `${url_images}/product.png`})`}}></div></Col>
                    <Col xs={9}><p className='hover mb-0' style={{  }} >{capitalizeFirstLetter(pro.titulo)} {extra_string ? extra_string : false}</p></Col>
                </Row>
            default:
                return <Link to={`product-edit-${pro._id}`}>{pro.titulo} {extra_string ? extra_string : false}</Link>
        }
    }

    const busquedaEstaticView = () => {
        if(loadingCodigos) return <div>
                <Spinner animation='border' />
                <h6 className='mb-0'>CARGANDO RESULTADOS</h6>
        </div>
        if(!showResults) return false
        if(resultadosCodigoBusqueda.length < 1) return false
        return <div>
            {
                resultadosCodigoBusqueda.map((codigo,pos) => {
                    return <div className="p-2" key={`${codigo._id}`} style={{ borderBottom: resultadosCodigoBusqueda.length === (pos+1) ? "none" : "1px solid #f1f0f0" }}>
                        {showComponentByType(codigo, `$${showAmmount(codigo.precio)}`) }
                    </div>
                })
            }
        </div>
    }
    const busquedaPalabra = () => {
        if(loadingCodigos) return <div style={{ position: "absolute", zIndex: 9999999999999, width: "100%" }}>
            <Card className='p-3'>
                <Spinner animation='border' />
                <h6 className='mb-0'>CARGANDO RESULTADOS</h6>
            </Card>
        </div>
        
        if(!showResults) return false
        
        if(resultadosCodigoBusqueda.length < 1) return false

        return <div style={{ position: "absolute", top: "100%", zIndex: 9999999999999, width: "100%", maxWidth: 400, maxHeight: "60vh", overflowY: "auto", overflowX: "hidden" }}>
            <Card className='p-3'>
            {
                resultadosCodigoBusqueda.map((codigo,pos) => {
                    return <div className="p-2" key={`${codigo._id}`} style={{ borderBottom: resultadosCodigoBusqueda.length === (pos+1) ? "none" : "1px solid #f1f0f0" }}>
                        {showComponentByType(codigo, `$${showAmmount(codigo.precio)}`) }
                    </div>
                })
            }
            </Card>
        </div>
    }

    const openDialog = () => {
        return setShowDialog(true)
    }

    const handleClose = () => {
        setShowDialog(false)
    }

    const viewBig = () => {
        return <div>
            <FaSearch size={25} className="hover" onClick={() => openDialog()} />
                <Dialog
                    open={showDialog}
                    onClose={handleClose}
                    sx={{ p: isMobile ? 0 : 10 }}
                    fullWidth
                    maxWidth={isMobile ? "xl" : "md"}
                >
                    <Box sx={{ p: 3 }}>
                    <h4 className="mb-4">Buscar producto</h4>
                    <div style={{ height: 400 }}>
                    {renderSearch(true)}
                    </div>
                    </Box>
                </Dialog>
        </div>
    }

    const renderSearch = (onlySearch) => {
        const searchBox = <div>
            <FaSearch style={{ marginLeft: 15, position: "relative" }} />
            <input 
                    className='form-control word-search' 
                    // autoFocus 
                    value={codigoBusqueda}
                    autoComplete="off"
                    style={{ background: "#f1f0f0", paddingLeft: 40, marginTop: -30 }}
                    name="codigo_busqueda" 
                    placeholder='BUSCAR' 
                    onChange={handleChangeCodigo} />
            </div>

        if(onlySearch) return <div>
            {searchBox}
            <div className="mt-2">{busquedaEstaticView()}</div>
        </div>
        
        return <div>
            {searchBox}
            {busquedaPalabra()}
        </div>
    }

    if(type_view === "big") return <div>
        {viewBig()}
    </div>

    return <div>{renderSearch()}</div>
}

export  default BuscadorProductoPublico